import I18n from 'i18n-js';

/**
 * Transform an integer into a pretty string with commas in the right places.
 *
 * I18n-js only version of $h.commaizeInt from
 * app/assets/javascripts/core_pre_webpack/utils/more_text_helpers.coffee
 */
const commaize = (x: number, usedLocale?: string) => {
  if (x == null) return x;

  if (!usedLocale) {
    return I18n.toNumber(x, { precision: 0 });
  } else {
    const oldLocale = I18n.currentLocale();
    I18n.locale = usedLocale;
    const commaized = I18n.toNumber(x, { precision: 0 });
    I18n.locale = oldLocale;
    return commaized;
  }
};
export default commaize;
